<template>
  <div class="article-image-reel">
    <div class="carousel scroller">
      <div v-for="slide in slides" :key="slide.id" class="slide">
        <template v-if="slide.images">
          <div class="image">
            <div v-if="slide.text" class="image__gradient">
              <Picture :images="slide.images" />
            </div>
            <Picture v-else :images="slide.images" />
          </div>
        </template>
        <template v-else>
          <video
            ref="video"
            class="video"
            autoplay=""
            playsinline=""
            muted=""
            loop=""
          >
            <source :src="slide.videoUrl" type="video/mp4" />
          </video>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";

export default {
  name: "ArticleImageReel",
  components: {
    Picture,
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.article-image-reel {
  margin: 0 auto 40px;
  max-width: 1200px;

  @include respond-above(md) {
    margin: 0 auto 60px;
  }
}

.image {
  line-height: 0;
  position: relative;
}

.carousel {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 0 0 20px 0;

  & > * {
    flex: 1 0 87.5%;
    margin: 0;

    @include respond-above(md) {
      max-width: 50%;
      flex: 1 0 50%;
    }
  }
}

.video {
  max-width: 100%;
  width: 100%;
}
</style>
